import { useLingui } from '@lingui/react/macro';
import { Zap } from 'lucide-react';
import { Image } from '@/routes/-components/image';
import { Eyebrow } from '../primitives';
import { Expand, ExpandGroup, EXPAND_STEP_ROOMY } from '../expand';
import { CoinsTileIllustration } from '../home/coins-tile-illustration';
import { LiveDonations } from './live-donations';

/** Tracking is spelled out: the hand-off's -0.02em is not `tracking-tight` (-0.025em). */
export function Hero() {
	const { t } = useLingui();
	return (
		<ExpandGroup step={EXPAND_STEP_ROOMY} asChild>
			<section className="mx-auto grid max-w-[1440px] items-center gap-10 px-6 pt-10 pb-16 md:pb-24 lg:grid-cols-[minmax(0,646px)_minmax(0,1fr)] lg:gap-16 lg:pt-16 xl:px-10">
				<div className="flex flex-col items-start gap-6">
					<Eyebrow icon={<Zap className="text-brand-strong size-4 fill-current" />}>{t`Solutions`}</Eyebrow>
					<div className="flex flex-col gap-2">
						<h1 className="text-4xl leading-[1.143] font-medium tracking-[-0.02em] text-balance md:text-[3.5rem]">
							{t`Technology that turns everyday purchases into social impact`}
						</h1>
						<p className="text-ink max-w-[559px] text-base leading-[1.5]">
							{t`Since 2013, at Worldcoo we build fundraising tools so that companies, their customers and their employees can finance social projects easily, comfortably and with full transparency.`}
						</p>
					</div>
				</div>

				<div className="flex flex-col gap-6">
					{/* `radius`: the redesign's one 28px card, not `rounded-3xl`; the opening clip must match the box. */}
					<div className="grid grid-cols-[1.34fr_1fr] gap-6">
						<Expand index={0} radius="1.75rem" asChild>
							<div className="bg-sand aspect-[337/323] overflow-hidden rounded-[1.75rem]">
								<Image
									src="/redesign/shop-assistant-contactless.jpg"
									alt={t`A shop assistant accepting a contactless payment`}
									height={646}
									aspectRatio={337 / 323}
									objectFit="cover"
									className="h-full w-full object-cover!"
								/>
							</div>
						</Expand>
						<Expand index={1} radius="1.75rem" asChild>
							<div className="bg-sage relative aspect-[251/323] overflow-hidden rounded-[1.75rem]">
								<CoinsTileIllustration
									palette="sage"
									portrait
									label={t`Hands catching euro coins`}
									className="absolute inset-0 h-full w-full"
								/>
							</div>
						</Expand>
					</div>

					<LiveDonations />
				</div>
			</section>
		</ExpandGroup>
	);
}
